<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import ItemList from "@/components/modals/item-list";

export default {
    components: {
        ItemList
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            fields: [
                {
                    key: "name",
                    sortable: true,
                },
                {
                    key: "description",
                    sortable: true,
                },
                {
                    key: "items",
                    sortable: false,
                },
                {
                    key: "actions",
                    thStyle: { width: "90px" },
                },
            ],
            form: {
                id: 0,
                name: null,
                description: null,
                campusId: null,
            },
            indexSelected: -1,
            tableBusy: false,
            selectedPackage: {},
        };
    },
    computed: {
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.tableData.length;
        },
    },
    validations: {
        form: {
            name: { required },
            description: { required },
        },
    },
    methods: {
        async getItems() {
            const wait = (delay, ...args) =>new Promise((resolve) =>setTimeout(resolve, delay, ...args));
            this.$store.dispatch('data/mutateGlobalStop', false);
            for await(const item of this.tableData){
                if(this.$store.state.data.globalStop){
                    break;
                }
                if(item.items.length == 0){
                    await this.$store
                        .dispatch("packageitem/GetPackageItemByPackage", item.id)
                        .then((res) => {
                            item.items = res.data;
                            item.itemLoading = false;
                        })
                        .catch(() => {
                            item.itemLoading = false;
                            this.showToast("Something went wrong!", "error");
                        });
                    await wait(1000);
                }
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addPackage() {
            this.onReset();
            this.modalTitle = "Create New Package";
            this.$bvModal.show("pkg-modal");
        },
        onReset() {
            this.form = {
                id: 0,
                name: "",
                description: "",
                campusId: this.$store.state.data.campus.id,
            };
        },
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                if (this.form.id > 0) {
                    this.$store
                        .dispatch("itempackage/UpdateItemPackage", this.form)
                        .then((res) => {
                            res.data.itemLoading = this.form.itemLoading;
                            res.data.items = this.form.items;
                            this.tableData.splice(
                                this.indexSelected,
                                1,
                                res.data
                            );
                            this.$bvModal.hide("pkg-modal");
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                } else {
                    this.$store
                        .dispatch("itempackage/CreateItemPackage", this.form)
                        .then((res) => {
                            res.data.items = [];
                            res.data.itemLoading = false;
                            this.tableData.push(res.data);
                            this.$bvModal.hide("pkg-modal");
                            this.showToast("Successfully created!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
                this.submitted = false;
            }
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.indexSelected = this.tableData.indexOf(props.item);
            this.modalTitle = "Update Package";
            this.$bvModal.show("pkg-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "itempackage/DeleteItemPackage",
                            props.item.id
                        )
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        addItems(props) {
            this.selectedPackage = props;
            // this.$refs.itemList.changeCycle(this.$store.state.data.cycle);
            this.$bvModal.show("item-list-modal");
        },
        dropData(event) {
            var data = [];
            event.forEach(item => {
                data.push({
                    itemPackageId: this.selectedPackage.id,
                    itemId: item.id,
                });
            })
            this.$store
                .dispatch("packageitem/CreateMultiplePackageItem", data)
                .then((res) => {
                    res.data.forEach(item => {
                        this.selectedPackage.items.push(item);
                    })
                })
                .catch((err) => {
                    this.showToast("Cannot be deleted!", "error");
                });
        },
        getPackages() {
            if(this.tableData.length == 0){
                this.tableBusy = true;
                this.$store
                .dispatch(
                    "itempackage/GetItemPackage",
                    this.$store.state.data.campus.id
                )
                .then((res) => {
                    res.data.map((item) => {
                        item.items = [];
                        item.itemLoading = true;
                    });
                    this.tableData = res.data;
                    this.tableBusy = false;
                    this.getItems();
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
            }else{
                this.getItems();
            }
        },
        removeFromList(props, row){
            var index = row.items.indexOf(props);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "packageitem/DeletePackageItem",
                            props.id
                        )
                        .then((res) => {
                            if (res.status == 204) {
                                row.items.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
    },
};
</script>

<template>
    <div>
        <item-list
            ref="itemList"
            :multiple="true"
            @dropData="dropData"
        ></item-list>
        <b-modal
            id="pkg-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="slForm"
            >
                <div class="mb-3">
                    <label for="name">Package Name </label>
                    <input
                        autocomplete="off"
                        id="name"
                        type="text"
                        v-model="form.name"
                        placeholder="Enter Package Name..."
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && $v.form.name.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.name.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.name.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="description">Description </label>
                    <input
                        autocomplete="off"
                        id="description"
                        type="text"
                        v-model="form.description"
                        placeholder="Enter Description..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && $v.form.description.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.description.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.description.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('pkg-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="row">
            <div class="col-12">
                <div class="card border">
                    <div class="card-body">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                            "
                        >
                            <h4 class="card-title m-0">Package List</h4>
                            <button
                                type="button"
                                @click="addPackage()"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                "
                            >
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="form-select form-select-sm"
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                class="datatables"
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                :busy="tableBusy"
                                @filtered="onFiltered"
                                bordered
                                outlined
                                hover
                                striped
                                show-empty
                            >
                                <template #empty="scope">
                                    <div class="text-center">
                                        {{ scope.emptyText }}
                                    </div>
                                </template>
                                <template #table-busy>
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div
                                                    class="
                                                        spinner-chase
                                                        w-20px
                                                        h-20px
                                                    "
                                                >
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template #row-details="row">
                                    <div class="p-0"> 
                                        <div class="text-right"><a href="javascript:void(0);" @click="row.toggleDetails()">Hide Details</a></div>
                                        <div class="table-responsive">
                                            <table
                                                class="
                                                    table table-centered
                                                    align-middle
                                                    project-list-table
                                                    border-collapse-none
                                                "
                                            >
                                                <tbody>
                                                    <tr v-for="x in row.item.items" :key="x.id">
                                                        <td>
                                                            <div class="d-flex justify-content-between align-items-center">
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div
                                                                        class="me-2"
                                                                    >
                                                                        <div
                                                                            style="
                                                                                height: 50px;
                                                                                width: 50px;
                                                                            "
                                                                            class="
                                                                                bg-secondary
                                                                                d-flex justify-content-center align-items-center
                                                                            "
                                                                        >
                                                                            <img
                                                                                v-if="
                                                                                    x.item
                                                                                        .thumbnail"
                                                                                :src="`
                                                                                ${$store.state.data.rootFileDirectory}Procurement/${x.item.thumbnail}
                                                                                `"
                                                                                class="
                                                                                    img-fluid
                                                                                "
                                                                                style="
                                                                                    height: 50px;
                                                                                    width: 50px;
                                                                                "
                                                                                alt=""
                                                                            />
                                                                            <span v-if="!x.item.thumbnail" class="font-size-15">{{x.item.itemName.charAt(0)}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            {{
                                                                                x.item.itemName
                                                                            }}
                                                                        </div>
                                                                        <div>
                                                                            <small>
                                                                            {{
                                                                                x.item.description
                                                                            }}
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td style="width:50px;">
                                                            <div class="d-flex align-items-center justify-content-center">
                                                                <i class="bx bx-trash font-size-18 text-danger cursor-pointer" title="Remove from List" @click="removeFromList(x, row.item)"></i>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </template>
                                <template #cell(items)="row">
                                    <div v-if="row.item.itemLoading">
                                        <div
                                            class="
                                                d-flex
                                                justify-content-center
                                                align-items-center
                                            "
                                        >
                                            <div
                                                class="preloader-component me-2"
                                            >
                                                <div class="status">
                                                    <div
                                                        class="
                                                            spinner-chase
                                                            w-20px
                                                            h-20px
                                                        "
                                                    >
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <strong>Loading...</strong>
                                        </div>
                                    </div>
                                    <div
                                        class="avatar-group"
                                        v-if="
                                            row.item.items.length > 0 &&
                                            !row.item.itemLoading
                                        "
                                        @click="row.toggleDetails()"
                                    >
                                        <div class="avatar-group-item">
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                                ><img
                                                    v-if="
                                                        row.item.items[0].item
                                                            .thumbnail
                                                    "
                                                    :src="`${$store.state.data.rootFileDirectory}Procurement/${row.item.items[0].item.thumbnail}`"
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[0].item
                                                            .itemName
                                                    "
                                                    alt="First Image"
                                                />
                                                <span
                                                    v-else
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-gradient bg-primary
                                                        text-white
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[0].item
                                                            .itemName
                                                    "
                                                    >{{
                                                        row.item.items[0].item.itemName.charAt(
                                                            0
                                                        )
                                                    }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 1"
                                        >
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                                ><img
                                                    v-if="
                                                        row.item.items[1].item
                                                            .thumbnail
                                                    "
                                                    :src="`${$store.state.data.rootFileDirectory}Procurement/${row.item.items[1].item.thumbnail}`"
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        border-avatar
                                                    "
                                                    alt="Second Image"
                                                    :title="
                                                        row.item.items[1].item
                                                            .itemName
                                                    "
                                                />
                                                <span
                                                    v-else
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-success bg-gradient
                                                        text-white
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[1].item
                                                            .itemName
                                                    "
                                                    >{{
                                                        row.item.items[1].item.itemName.charAt(
                                                            0
                                                        )
                                                    }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 2"
                                        >
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                                ><img
                                                    v-if="
                                                        row.item.items[2].item
                                                            .thumbnail
                                                    "
                                                    :src="`${$store.state.data.rootFileDirectory}Procurement/${row.item.items[2].item.thumbnail}`"
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        border-avatar
                                                    "
                                                    alt="Third Image"
                                                    :title="
                                                        row.item.items[2].item
                                                            .itemName
                                                    "
                                                />
                                                <span
                                                    v-else
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-warning bg-gradient
                                                        text-white
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[2].item
                                                            .itemName
                                                    "
                                                    >{{
                                                        row.item.items[2].item.itemName.charAt(
                                                            0
                                                        )
                                                    }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 3"
                                        >
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                                ><img
                                                    v-if="
                                                        row.item.items[3].item
                                                            .thumbnail
                                                    "
                                                    :src="`${$store.state.data.rootFileDirectory}Procurement/${row.item.items[3].item.thumbnail}`"
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        border-avatar
                                                    "
                                                    alt="Fourth Image"
                                                    :title="
                                                        row.item.items[3].item
                                                            .itemName
                                                    "
                                                />
                                                <span
                                                    v-else
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-danger bg-gradient
                                                        text-white
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[3].item
                                                            .itemName
                                                    "
                                                    >{{
                                                        row.item.items[3].item.itemName.charAt(
                                                            0
                                                        )
                                                    }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 4"
                                        >
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                            >
                                                <img
                                                    v-if="
                                                        row.item.items[4].item
                                                            .thumbnail
                                                    "
                                                    :src="`${$store.state.data.rootFileDirectory}Procurement/${row.item.items[4].item.thumbnail}`"
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        border-avatar
                                                    "
                                                    alt="Fifth Image"
                                                    :title="
                                                        row.item.items[4].item
                                                            .itemName
                                                    "
                                                />
                                                <span
                                                    v-else
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-white
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[4].item
                                                            .itemName
                                                    "
                                                    >{{
                                                        row.item.items[4].item.itemName.charAt(
                                                            0
                                                        )
                                                    }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 5"
                                        >
                                            <span
                                                class="
                                                    rounded-circle
                                                    avatar-xs
                                                    d-flex
                                                    align-items-center
                                                    justify-content-center
                                                    bg-white
                                                    border-avatar
                                                "
                                                >+{{
                                                    row.item.items.length - 5
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-success"
                                        v-if="!row.item.itemLoading"
                                        @click="addItems(row.item)"
                                        ><i class="bx bx-plus"></i
                                        >{{
                                            row.item.items.length > 0
                                                ? "Add More Items"
                                                : "Add Items"
                                        }}</a
                                    >
                                </template>
                                <template #cell(actions)="row">
                                    <div class="float-end">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i
                                                    class="fas fa-ellipsis-v"
                                                ></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="updateItem(row)"
                                                variant="secondary"
                                                ><i
                                                    class="
                                                        mdi mdi-update
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="deleteItem(row)"
                                                variant="danger"
                                                ><i
                                                    class="
                                                        mdi mdi-trash-can
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Delete</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>